<template>
  <div class="hy-list-box">
    <Header :pageTitle="columnName" />
    <van-dropdown-menu
      class="dropdown-box"
      active-color="#4A79F1"
      :close-on-click-outside="false"
    >
      <van-dropdown-item
        class="dropdown-box-item"
        title="会议类型"
        ref="typeParam"
        @open="typeOpen"
      >
        <div class="type-btn-box">
          <div
            :class="[
              'type-btn',
              typeParam.meetingType === 1 ? 'type-btn-active' : '',
            ]"
            @click="choseType(1)"
          >
            线上会议
          </div>
          <div
            :class="[
              'type-btn',
              typeParam.meetingType === 2 ? 'type-btn-active' : '',
            ]"
            @click="choseType(2)"
          >
            线下会议
          </div>
        </div>
        <p style="margin-bottom: 13px; font-size: 15px; color: #333">
          仅展示开放报名会议
        </p>
        <van-switch
          style="border: none"
          v-model="typeParam.open"
          active-color="#4A79F1"
          :active-value="1"
          inactive-color="#ddd"
          :inactive-value="''"
        />
        <van-button
          class="dropdown-btn"
          color="#4A79F1"
          block
          round
          @click="dropdownConfirm('typeParam')"
        >
          确认
        </van-button>
      </van-dropdown-item>
      <van-dropdown-item
        class="dropdown-box-item"
        title="会议时间"
        ref="timeParams"
        @open="timeOpen"
      >
        <div class="type-btn-box">
          <div
            :class="[
              'type-btn',
              timeParams.timeType === 1 ? 'type-btn-active' : '',
            ]"
            @click="choseTimeType(1)"
          >
            最近一周
          </div>
          <div
            :class="[
              'type-btn',
              timeParams.timeType === 2 ? 'type-btn-active' : '',
            ]"
            @click="choseTimeType(2)"
          >
            最近一月
          </div>
          <div
            :class="[
              'type-btn',
              timeParams.timeType === 3 ? 'type-btn-active' : '',
            ]"
            @click="choseTimeType(3)"
          >
            最近三月
          </div>
          <div
            :class="[
              'type-btn',
              timeParams.timeType === 4 ? 'type-btn-active' : '',
            ]"
            @click="choseTimeType(4)"
          >
            最近半年
          </div>
          <div
            :class="[
              'type-btn',
              timeParams.timeType === 5 ? 'type-btn-active' : '',
            ]"
            @click="choseTimeType(5)"
          >
            最近一年
          </div>
        </div>
        <p style="margin-bottom: 13px; font-size: 15px; color: #333">自定义</p>
        <div class="type-btn-box">
          <div class="type-btn time-btn" @click="openTime('meetingBeginTime')">
            <span v-if="timeParams.meetingBeginTime">{{
              timeParams.meetingBeginTime
            }}</span>
            <span v-else style="color: #999">开始时间</span>
          </div>
          <span class="time-text">至</span>
          <div class="type-btn time-btn" @click="openTime('meetingEndTime')">
            <span v-if="timeParams.meetingEndTime">{{
              timeParams.meetingEndTime
            }}</span>
            <span v-else style="color: #999">结束时间</span>
          </div>
        </div>
        <van-button
          class="dropdown-btn"
          color="#4A79F1"
          block
          round
          @click="dropdownConfirm('timeParams')"
        >
          确认
        </van-button>
      </van-dropdown-item>
      <van-dropdown-item
        class="dropdown-box-item area-dropdown-box-item"
        title="会议地点"
        ref="areaParam"
        @open="areaOpen"
      >
        <van-tree-select
          class="area-tree"
          :items="areaItems"
          height="350"
          :main-active-index="provinceIndex"
          :active-id="areaParam.cityCode"
          @click-nav="activeProvince"
          @click-item="activeCity"
        />
        <van-button
          class="dropdown-btn dropdown-clear-btn"
          type="default"
          round
          @click="clearArea"
        >
          清空
        </van-button>
        <van-button
          class="dropdown-btn"
          color="#4A79F1"
          round
          @click="dropdownConfirm('areaParam')"
        >
          确认
        </van-button>
      </van-dropdown-item>
    </van-dropdown-menu>
    <van-list
      v-model="loading"
      :finished="finished"
      :error="error"
      :offset="50"
      :finished-text="articleList.length > 0 ? '加载完毕' : ''"
      error-text="请求失败，点击重新加载"
      @load="onLoad"
    >
      <div class="hy-list" v-if="loading || articleList.length > 0">
        <XshyItem
          class="hy-list-item"
          v-for="item in articleList"
          :key="item.id"
          :title="item.title"
          :cover="item.cover"
          :beginTime="
            item.beginTime.slice(0, 10).replace(RegExp('-', 'g'), '.')
          "
          :address="item.province + '-' + item.city"
          @click.native="toDetail(item.id, item.goodsId, item.open)"
        />
      </div>
      <noneList noneType="hyList" v-else />
    </van-list>
    <van-popup
      v-model="timePopupShow"
      round
      position="bottom"
      :safe-area-inset-bottom="true"
      :close-on-click-overlay="false"
    >
      <div class="time-popup-top">
        <span @click="timePopupShow = false">取消</span>
        <span @click="comfirmTime">确认</span>
      </div>
      <van-datetime-picker
        v-model="currentDate"
        :show-toolbar="false"
        :min-date="minDate"
        :max-date="maxDate"
        type="date"
      />
    </van-popup>
  </div>
</template>

<script>
import Header from "@/views/mobileView/components/header";
import XshyItem from "@/views/mobileView/components/listItem/xshyItem.vue";
import noneList from "@/views/mobileView/components/noneList.vue";
export default {
  name: "AcademicConference",
  components: {
    Header,
    XshyItem,
    noneList,
  },
  data() {
    return {
      columnName: "",
      typeParam: {
        meetingType: "",
        open: "",
      },
      timePopupShow: false,
      timePopupKey: "",
      currentDate: "",
      minDate: "",
      maxDate: "",
      timeType: "",
      timeParams: {
        timeType: "",
        meetingBeginTime: "",
        meetingEndTime: "",
      },
      searchParam: {
        pageNo: 0,
        pageSize: 20,
        channelId1: "14",
        beginDateTime: "",
        meetingType: "",
        open: "",
        meetingBeginTime: "",
        meetingEndTime: "",
        provinceCode: "",
        cityCode: "",
      },
      articleList: [],
      loading: false,
      finished: false,
      error: false,
      areaItems: [],
      provinceIndex: 0,
      areaParam: {
        cityCode: "",
      },
    };
  },
  created() {
    this.getProvince();
    this.getColumnName();
  },
  methods: {
    areaOpen() {
      this.areaParam.cityCode = this.searchParam.cityCode;
    },
    clearArea() {
      this.areaParam.cityCode = "";
    },
    activeCity(data) {
      this.areaParam.cityCode = data.id;
    },
    async activeProvince(index) {
      this.provinceIndex = index;
      if (this.areaItems[index].children.length === 0) {
        const res = await this.$apis.userServe.cityList({
          provinceCode: this.areaItems[index].id,
        });
        let cityArr = res.content.cityList.map((item) => {
          return {
            id: item.code,
            text: item.name,
          };
        });
        this.$set(this.areaItems[index], "children", cityArr);
      }
    },
    async getProvince() {
      const res = await this.$apis.userServe.proList();
      this.areaItems = res.content.provinceList.map((item) => {
        return {
          id: item.code,
          text: item.name,
          children: [],
        };
      });
      this.activeProvince(0);
    },
    choseTimeType(type) {
      this.timeParams.timeType = this.timeParams.timeType !== type ? type : "";
      this.timeParams.meetingBeginTime = "";
      this.timeParams.meetingEndTime = "";
    },
    comfirmTime() {
      this.timeParams[this.timePopupKey] = this.$global.transferDay(
        this.currentDate
      );
      this.timeParams.timeType = "";
      this.timePopupShow = false;
    },
    openTime(key) {
      this.minDate = new Date(
        new Date().setFullYear(new Date().getFullYear() - 30)
      );
      this.maxDate = new Date(
        new Date().setFullYear(new Date().getFullYear() + 30)
      );
      if (key === "meetingBeginTime") {
        if (this.timeParams.meetingEndTime) {
          let time = new Date(this.timeParams.meetingEndTime);
          let minTime = time.setFullYear(time.getFullYear() - 50);
          this.minDate = new Date(minTime);
          this.maxDate = new Date(this.timeParams.meetingEndTime);
        }
      } else {
        if (this.timeParams.meetingBeginTime) {
          let time = new Date(this.timeParams.meetingBeginTime);
          let maxTime = time.setFullYear(time.getFullYear() + 50);
          this.minDate = new Date(this.timeParams.meetingBeginTime);
          this.maxDate = new Date(maxTime);
        }
      }
      this.currentDate = this.timeParams[key]
        ? this.timeParams[key]
        : new Date();
      this.timePopupShow = true;
      this.timePopupKey = key;
    },
    timeOpen() {
      if (this.timeType) {
        this.timeParams.timeType = this.timeType;
      } else {
        this.timeParams.meetingBeginTime = this.searchParam.meetingBeginTime;
        this.timeParams.meetingEndTime = this.searchParam.meetingEndTime;
      }
    },
    typeOpen() {
      for (const key in this.typeParam) {
        this.typeParam[key] = this.searchParam[key];
      }
    },
    choseType(type) {
      this.typeParam.meetingType =
        this.typeParam.meetingType === type ? "" : type;
    },
    dropdownConfirm(type) {
      if (type === "timeParams") {
        let params = {
          meetingBeginTime: "",
          meetingEndTime: "",
        };
        if (this[type].timeType) {
          const nowData = new Date();
          let endTime = "";
          this.timeType = this[type].timeType;
          switch (this[type].timeType) {
            case 1:
              endTime = new Date(
                nowData.setTime(nowData.getTime() + 7 * 24 * 3600 * 1000)
              );
              break;
            case 2:
              endTime = new Date(nowData.setMonth(nowData.getMonth() + 1));
              break;
            case 3:
              endTime = new Date(nowData.setMonth(nowData.getMonth() + 3));
              break;
            case 4:
              endTime = new Date(nowData.setMonth(nowData.getMonth() + 6));
              break;
            case 5:
              endTime = new Date(
                nowData.setFullYear(nowData.getFullYear() + 1)
              );
              break;
          }
          params.meetingBeginTime = this.$global.transferDay(new Date());
          params.meetingEndTime = this.$global.transferDay(endTime);
        } else {
          this.timeType = "";
          params.meetingBeginTime = this[type].meetingBeginTime;
          params.meetingEndTime = this[type].meetingEndTime;
        }
        this.searchParam = { ...this.searchParam, ...params, ...{ pageNo: 1 } };
      } else if (type === "areaParam") {
        let params = {
          provinceCode: "",
          cityCode: "",
        };
        if (this.areaParam.cityCode !== "") {
          params.provinceCode = this.areaItems[this.provinceIndex].id;
          params.cityCode = this.areaParam.cityCode;
        }
        this.searchParam = { ...this.searchParam, ...params, ...{ pageNo: 1 } };
      } else {
        this.searchParam = {
          ...this.searchParam,
          ...this[type],
          ...{ pageNo: 1 },
        };
      }
      this.$refs[type].toggle();
      this.getList();
    },
    // 获取栏目名称 (会议id为14)
    async getColumnName() {
      const resp = await this.$apis.searchServe.getNavList();
      resp.data.forEach((item) => {
        if (item.id === "14") this.columnName = item.columnName;
      });
    },
    // 触底加载
    onLoad() {
      this.searchParam.pageNo += 1;
      this.getList();
    },
    // 获取列表
    async getList() {
      this.loading = true;
      if (this.searchParam.pageNo == 1) {
        this.articleList = [];
        this.searchParam.beginDateTime = this.$global.transferDate(new Date());
      }
      let paramsObj = {};
      for (const key in this.searchParam) {
        if (this.searchParam[key]) {
          paramsObj[key] = this.searchParam[key];
        }
      }
      console.log(paramsObj, "paramsObj");
      const resp = await this.$apis.mainServe.getlistByColumnId(paramsObj);
      if (resp.resultCode == 200) {
        this.finished = resp.data.list.length < 20;
        this.articleList.push(...resp.data.list);
      } else {
        this.error = true;
      }
      this.loading = false;
    },
    // 点击进入详情页
    toDetail(id, goodsId, open) {
      window.open(
        this.$global.meetingH5Url +
          `pagesModule/meetingDetails/index?type=8&id=${id || goodsId}${
            open ? "&open=" + open : ""
          }`,
        "_self"
      );
    },
  },
};
</script>

<style scoped lang="scss">
.hy-list-box {
  padding-top: 44px;
  min-height: 100vh;
  background-color: #f5f5f5;

  .dropdown-box {
    &::v-deep .van-dropdown-menu__title {
      &::after {
        content: "\e65e";
        margin-top: -6px;
        right: -10px;
        font: normal normal normal 14px/1 vant-icon;
        border: none;
        transform: rotate(0deg);
      }
    }

    &::v-deep .van-dropdown-menu__title--down {
      &::after {
        margin-top: -6px;
        transform: rotate(180deg);
      }
    }
    .dropdown-box-item {
      &::v-deep .van-popup {
        padding: 20px 15px;
        border-radius: 0 0 16px 16px;
        .type-btn-box {
          margin-bottom: 14px;
          .type-btn {
            display: inline-block;
            margin-bottom: 10px;
            margin-right: 10px;
            width: 76px;
            height: 35px;
            line-height: 35px;
            text-align: center;
            font-size: 13px;
            color: #333333;
            border-radius: 18px;
            background-color: #f5f5f5;
          }
          .type-btn-active {
            line-height: 34px;
            color: #4a79f1;
            background-color: #fff;
            border: 1px solid #4a79f1;
          }
          .time-btn {
            margin-bottom: 0;
            width: 92px;
          }
          .time-text {
            margin-right: 10px;
          }
        }
        .dropdown-btn {
          margin-top: 25px;
        }
      }
    }
    .area-dropdown-box-item {
      &::v-deep .van-popup {
        padding: 0;
        padding-bottom: 10px;
        .area-tree {
          .van-sidebar-item--select {
            .van-sidebar-item__text {
              color: #4a79f1;
            }
            &::before {
              display: none;
            }
          }
          .van-tree-select__item--active {
            color: #4a79f1;
          }
        }
        .dropdown-btn {
          margin-top: 10px;
          width: 249px;
        }
        .dropdown-clear-btn {
          margin: 0 15px;
          width: 81px;
        }
      }
    }
  }

  .hy-list {
    .hy-list-item {
      margin: 12px auto;
      padding-bottom: 15px;
      width: 351px;
      // height: 275px;
      border-radius: 8px;
      background-color: #fff;
      overflow: hidden;
    }
  }
  .time-popup-top {
    display: flex;
    justify-content: space-between;
    padding: 0 24px;
    height: 55px;
    line-height: 55px;
    border-bottom: 1px solid #ededed;
    font-size: 16px;
    color: #333333;
  }
}
</style>
